import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {
  Grid,
  IconButton,
  MobileStepper,
  Stack,
  StepButton,
} from "@mui/material";
import stepperNav from "./stepperNav";
import ReplyIcon from "@mui/icons-material/Reply";

const steps = [
  "Lieu",
  "Motif",
  "Praticien",
  "Crénaux",
  "Coordonnées",
  "Confirmation",
];

const PageStepper = ({ currentPageNo, page, setPage }) => {
  const [activeStep, setActiveStep] = React.useState(1);
  const [skipped, setSkipped] = React.useState(new Set());
  const [isMobile, setIsMobile] = useState(
    !window.matchMedia("(min-width: 700px)").matches
  );

  useEffect(() => {
    window.matchMedia("(min-width: 768px)").addEventListener("change", (e) => {
      setIsMobile(!e.matches);
    });
    setActiveStep(currentPageNo);
  }, [isMobile, currentPageNo]);

  const isStepOptional = (step) => {
    // tous les champs sont obligatoires
    return false;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleStepClick = () => {
    const index = page.page - 1;
    stepperNav(index, page, setPage);
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid item xs={3}>
        <Box
          sx={{ width: "75%" }}
          style={{ paddingTop: 10, justifyItem: "center" }}
        >
          {isMobile ? (
            <Stack direction={"row"} spacing={2}>
              <MobileStepper
                variant="dots"
                steps={steps.length}
                position="bottom"
                activeStep={activeStep}
                sx={{ flexGrow: 1, maxWidth: 800 }}
                backButton={
                  <IconButton
                    aria-label="backward"
                    size="small"
                    onClick={handleStepClick}
                    color={
                      page.page > 0 && page.page < 5 ? "primary" : "default"
                    }
                  >
                    <ReplyIcon />
                  </IconButton>
                }
                nextButton={<Box />}
              />
            </Stack>
          ) : (
            <Stepper activeStep={activeStep}>
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                if (isStepOptional(index)) {
                  labelProps.optional = (
                    <Typography variant="caption">Optional</Typography>
                  );
                }
                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label} {...stepProps}>
                    <StepButton
                      onClick={() => stepperNav(index, page, setPage)}
                    >
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </StepButton>
                  </Step>
                );
              })}
            </Stepper>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default PageStepper;
